

// export const enData = {
//   title: "Privacy and Cookie Policy – Danghuan",
//   sections: [
//     {
//       title: "Introduction",
//       content: `
//         <p>This Privacy and Cookie Policy explains how Danghuan Europe S.L. ('we', 'us', or 'Danghuan') collects, uses, and protects your personal data when you interact with our websites and services. This policy applies to residents of the European Economic Area (EEA) and the United Kingdom (UK) and complies with the General Data Protection Regulation (GDPR) and UK GDPR.</p>
//       `
//     },
//     {
//       title: "Scope of this Policy",
//       content: `
//         <p>This Policy applies to:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Visitors to our website (https://www.danghuan.eu)</li>
//           <li style='margin-bottom: 8px;'>Customers and potential customers</li>
//           <li style='margin-bottom: 8px;'>Users of our trade-in and resale services</li>
//           <li style='margin-bottom: 8px;'>Representatives of business partners and platform affiliates</li>
//         </ul>
//       `
//     },
//     {
//       title: "What Data We Collect",
//       content: `
//         <p>Depending on your interaction with us, we may collect:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Full name, address, email, and phone number</li>
//           <li style='margin-bottom: 8px;'>IBAN, Sort Code & Account Number, PayPal, Revolut, or other banking details</li>
//           <li style='margin-bottom: 8px;'>Device details (model, brand, condition, pricing info, IMEI)</li>
//           <li style='margin-bottom: 8px;'>Communication history with customer service</li>
//           <li style='margin-bottom: 8px;'>Marketing preferences and campaign interactions</li>
//           <li style='margin-bottom: 8px;'>IP address, browser type, session ID, and location</li>
//           <li style='margin-bottom: 8px;'>Platform data from Shopify, Amazon, TEMU, Back Market</li>
//         </ul>
//         <p>We may receive certain data about you from our platform or logistics partners (e.g., Shopify, Amazon, Back Market, TEMU) when you interact with their platforms in connection with our services. This includes order data, shipping address, and transaction status.</p>
//       `
//     },
//     {
//       title: "Use of Personal Data",
//       content: `
//         <p>We use your data to:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Process orders and manage logistics (including returns and trade-ins)</li>
//           <li style='margin-bottom: 8px;'>Communicate with you regarding your transactions</li>
//           <li style='margin-bottom: 8px;'>Provide customer service and support</li>
//           <li style='margin-bottom: 8px;'>Send marketing communications (if opted-in)</li>
//           <li style='margin-bottom: 8px;'>Comply with legal obligations (e.g., tax or anti-fraud checks)</li>
//           <li style='margin-bottom: 8px;'>Improve user experience and optimize our platforms</li>
//         </ul>
//       `
//     },
//     {
//       title: "Cookies",
//       content: `
//         <p>We use cookies to enhance your browsing experience and improve our services. Cookies may collect:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>IP address and geolocation</li>
//           <li style='margin-bottom: 8px;'>Browser/device identifiers</li>
//           <li style='margin-bottom: 8px;'>Usage behavior (pages viewed, time on site, clicks)</li>
//         </ul>
//         <p>Types of cookies:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Strictly Necessary Cookies</li>
//           <li style='margin-bottom: 8px;'>Functional Cookies</li>
//           <li style='margin-bottom: 8px;'>Performance Cookies</li>
//           <li style='margin-bottom: 8px;'>Advertising Cookies</li>
//         </ul>
//         <p>You may configure or revoke cookie settings anytime through your browser or the cookie banner.</p>
//       `
//     },
//     {
//       title: "Third Parties We Share Data With",
//       content: `
//         <p>We share data with payment and logistics partners based on contract necessity; and with analytics providers based on your cookie consent.</p>
//         <p>We may share your data with:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Payment partners: PayPal, Revolut, VISA, Mastercard, Stripe</li>
//           <li style='margin-bottom: 8px;'>Logistics providers: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
//           <li style='margin-bottom: 8px;'>Platform partners: Shopify, Amazon, TEMU, BackMarket</li>
//           <li style='margin-bottom: 8px;'>Marketing and analytics providers: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
//           <li style='margin-bottom: 8px;'>IT providers, consultants, legal advisors</li>
//           <li style='margin-bottom: 8px;'>Government authorities if required by law</li>
//         </ul>
//         <p>Data may be transferred outside the EEA/UK under EU-approved safeguards such as Standard Contractual Clauses.</p>
//       `
//     },
//     {
//       title: "Use of Third-Party Brand Logos",
//       content: `
//         <p>Our website displays brand names and logos such as Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google, and others solely to identify compatible devices for trade-in or resale purposes. All trademarks belong to their respective owners. Danghuan Europe is an independent service provider and is not affiliated with, endorsed by, or sponsored by these brands unless explicitly stated. The presence of these logos does not imply any formal business relationship.</p>
//         <p>The use of third-party brand logos is solely for descriptive purposes. All such brands retain their respective rights, and no association with Danghuan is implied.</p>
//       `
//     },
//     {
//       title: "Data Retention and Security",
//       content: `
//         <p>We retain your data only as long as necessary to fulfill the above purposes or as required by law. We employ appropriate technical and organizational measures to protect your data, including encryption, access control, and secure storage.</p>
//       `
//     },
//     {
//       title: "Your Rights",
//       content: `
//         <p>We aim to respond to all valid data requests within one month. To protect your privacy, we may need to verify your identity before processing your request.</p>
//         <p>You have the right to:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Access and rectify your data</li>
//           <li style='margin-bottom: 8px;'>Request deletion ('right to be forgotten')</li>
//           <li style='margin-bottom: 8px;'>Object to or restrict processing</li>
//           <li style='margin-bottom: 8px;'>Withdraw consent at any time</li>
//           <li style='margin-bottom: 8px;'>Request data portability (where applicable)</li>
//         </ul>
//         <p>To exercise these rights, contact us at <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
//       `
//     },
//     {
//       title: "Policy Updates",
//       content: `
//         <p>We may update this Policy to reflect changes in legal requirements or our data practices. The latest version will always be available on our website.</p>
//       `
//     },
//     {
//       title: "Contact Us",
//       content: `
//         <p>If you have questions or wish to exercise your rights, please contact us:</p>
//         <ul>
//           <li style='margin-bottom: 8px;'>Danghuan Europe S.L.</li>
//           <li style='margin-bottom: 8px;'>Email: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
//           <li style='margin-bottom: 8px;'>Website: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
//         </ul>
//         <p>You may also file a complaint with your local data protection authority or with the Spanish Data Protection Agency (AEPD).</p>
//       `
//     },
//     {
//       title: "Addendum – Extended Legal and Cookie Information",
//       subsections: [
//         {
//           title: "1. Legal Basis for Data Processing",
//           content: `
//             <p>The legal basis for processing your personal data includes:</p>
//             <ul>
//               <li style='margin-bottom: 8px;'>Performance of a contract (e.g. processing trade-in orders, sending payments)</li>
//               <li style='margin-bottom: 8px;'>Compliance with legal obligations (e.g. tax reporting, identity verification)</li>
//               <li style='margin-bottom: 8px;'>Your consent (e.g. marketing communications or third-party cookies)</li>
//               <li style='margin-bottom: 8px;'>Legitimate interests (e.g. fraud prevention, internal analytics, service improvement)</li>
//             </ul>
//           `
//         },
//         {
//           title: "2. Fraud Prevention Measures",
//           content: `
//             <p>We may use your personal information (e.g. device serial number, transaction pattern, IP geolocation, IBAN ownership) to conduct fraud detection using publicly available databases and anti-fraud service providers. This is done under our legitimate interest in preventing identity theft and misuse of our services.</p>
//             <p>We do not make decisions solely based on automated processing that significantly affect you.</p>
//           `
//         },
//         {
//           title: "3. Data Handling on External Marketplaces",
//           content: `
//             <p>If you purchase or sell devices via third-party platforms like Amazon, Shopify, TEMU, or Back Market, Danghuan may receive your order information, shipping address, and payment confirmation via encrypted API or secure back-office channel, solely for the purpose of fulfilling your transaction and providing after-sales support.</p>
//           `
//         },
//         {
//           title: "4. Cookie Categories and Details",
//           content: `
//             <p>You may review the full list of cookies we use — including name, provider, purpose, duration, and type (first-party or third-party) — in the table below. This includes analytics cookies from Google Analytics, retargeting cookies from Meta, and payment cookies from PayPal.</p>
//             <table style='border-collapse: collapse; width: 100%;'>
//               <thead>
//                 <tr>
//                   <th style='border: 1px solid #ddd; padding: 8px;'>Category</th>
//                   <th style='border: 1px solid #ddd; padding: 8px;'>Cookie Name</th>
//                   <th style='border: 1px solid #ddd; padding: 8px;'>Provider</th>
//                   <th style='border: 1px solid #ddd; padding: 8px;'>Purpose</th>
//                   <th style='border: 1px solid #ddd; padding: 8px;'>Duration</th>
//                   <th style='border: 1px solid #ddd; padding: 8px;'>Type</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Strictly Necessary</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Stores cookie preferences</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>1 year</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>First-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Strictly Necessary</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Maintains session state across pages</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>First-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Functional</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Remembers selected language preference</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>First-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Functional</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Enables live chat support</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>6 months</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Performance</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Collects site usage statistics</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>2 years</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Performance</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Tracks user behavior across sessions</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>24 hours</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Performance</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Persists user session across pages</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>1 year</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Delivers personalized ads based on behavior</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>3 months</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Tracks user interactions and conversions</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>13 months</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Tracks users across websites for marketing</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>1 day</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Used for conversion tracking</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>3 months</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//                 <tr>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Identifies visitors for email marketing campaigns</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>2 years</td>
//                   <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
//                 </tr>
//               </tbody>
//             </table>
//           `
//         },
//         {
//           title: "5. Promotions, Campaigns and Surveys",
//           content: `
//             <p>When you participate in our promotions, surveys, or contests, we may collect your name, contact details, and additional information specific to the event (e.g. age, location). This data is used solely to administer the event, contact winners, and improve future campaigns.</p>
//           `
//         },
//         {
//           title: "6. Supervisory Authorities",
//           content: `
//             <p>You may file a complaint with the following supervisory authorities if you believe your data rights have been violated:</p>
//             <ul>
//               <li style='margin-bottom: 8px;'>In Spain: Spanish Data Protection Agency (AEPD) – <a href="https://www.aepd.es" target="_blank">www.aepd.es</a></li>
//               <li style='margin-bottom: 8px;'>In the United Kingdom: Information Commissioner's Office (ICO) – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
//               <li style='margin-bottom: 8px;'>In the European Union: you can find the relevant national supervisory authority for your country on the website of the European Data Protection Board (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
//             </ul>
//           `
//         }
//       ]
//     }
//   ],
//   footer: `
//     <p>© 2025 DANGHUAN EUROPE S.L. All rights reserved.<br>
//     Policy version: v1.0 | Last updated: 30/05/2025</p>
//   `
// };


export const enData = {
  title: "Privacy and Cookie Policy – Danghuan",
  sections: [
    {
      title: "Introduction",
      content: `
        <p>This Privacy and Cookie Policy explains how Danghuan Europe S.L. ('we', 'us', or 'Danghuan') collects, uses, and protects your personal data when you interact with our websites and services. This policy applies to residents of the European Economic Area (EEA) and the United Kingdom (UK) and complies with the General Data Protection Regulation (GDPR) and UK GDPR.</p>
      `
    },
    {
      title: "Scope of this Policy",
      content: `
        <p>This Policy applies to:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Visitors to our website (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Customers and potential customers</li>
          <li style='margin-bottom: 8px;'>Users of our trade-in and resale services</li>
          <li style='margin-bottom: 8px;'>Representatives of business partners and platform affiliates</li>
        </ul>
      `
    },
    {
      title: "What Data We Collect",
      content: `
        <p>Depending on your interaction with us, we may collect:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Full name, address, email, and phone number</li>
          <li style='margin-bottom: 8px;'>IBAN, Sort Code & Account Number, PayPal, Revolut, or other banking details</li>
          <li style='margin-bottom: 8px;'>Device details (model, brand, condition, pricing info, IMEI)</li>
          <li style='margin-bottom: 8px;'>Communication history with customer service</li>
          <li style='margin-bottom: 8px;'>Marketing preferences and campaign interactions</li>
          <li style='margin-bottom: 8px;'>IP address, browser type, session ID, and location</li>
          <li style='margin-bottom: 8px;'>Platform data from Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>We may receive certain data about you from our platform or logistics partners (e.g., Shopify, Amazon, Back Market, TEMU) when you interact with their platforms in connection with our services. This includes order data, shipping address, and transaction status.</p>
      `
    },
    {
      title: "Use of Personal Data",
      content: `
        <p>We use your data to:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Process orders and manage logistics (including returns and trade-ins)</li>
          <li style='margin-bottom: 8px;'>Communicate with you regarding your transactions</li>
          <li style='margin-bottom: 8px;'>Provide customer service and support</li>
          <li style='margin-bottom: 8px;'>Send marketing communications (if opted-in)</li>
          <li style='margin-bottom: 8px;'>Comply with legal obligations (e.g., tax or anti-fraud checks)</li>
          <li style='margin-bottom: 8px;'>Improve user experience and optimize our platforms</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>We use cookies to enhance your browsing experience and improve our services. Cookies may collect:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>IP address and geolocation</li>
          <li style='margin-bottom: 8px;'>Browser/device identifiers</li>
          <li style='margin-bottom: 8px;'>Usage behavior (pages viewed, time on site, clicks)</li>
        </ul>
        <p>Types of cookies:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Strictly Necessary Cookies</li>
          <li style='margin-bottom: 8px;'>Functional Cookies</li>
          <li style='margin-bottom: 8px;'>Performance Cookies</li>
          <li style='margin-bottom: 8px;'>Advertising Cookies</li>
        </ul>
        <p>You may configure or revoke cookie settings anytime through your browser or the cookie banner.</p>
      `
    },
    {
      title: "Third Parties We Share Data With",
      content: `
        <p>We share data with payment and logistics partners based on contract necessity; and with analytics providers based on your cookie consent.</p>
        <p>We may share your data with:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Payment partners: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Logistics providers: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Platform partners: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Marketing and analytics providers: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>IT providers, consultants, legal advisors</li>
          <li style='margin-bottom: 8px;'>Government authorities if required by law</li>
        </ul>
        <p>Data may be transferred outside the EEA/UK under EU-approved safeguards such as Standard Contractual Clauses.</p>
      `
    },
    {
      title: "Use of Third-Party Brand Logos",
      content: `
        <p>Our website displays brand names and logos such as Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google, and others solely to identify compatible devices for trade-in or resale purposes. All trademarks belong to their respective owners. Danghuan Europe is an independent service provider and is not affiliated with, endorsed by, or sponsored by these brands unless explicitly stated. The presence of these logos does not imply any formal business relationship.</p>
        <p>The use of third-party brand logos is solely for descriptive purposes. All such brands retain their respective rights, and no association with Danghuan is implied.</p>
      `
    },
    {
      title: "Data Retention and Security",
      content: `
        <p>We retain your data only as long as necessary to fulfill the above purposes or as required by law. We employ appropriate technical and organizational measures to protect your data, including encryption, access control, and secure storage.</p>
      `
    },
    {
      title: "Your Rights",
      content: `
        <p>We aim to respond to all valid data requests within one month. To protect your privacy, we may need to verify your identity before processing your request.</p>
        <p>You have the right to:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Access and rectify your data</li>
          <li style='margin-bottom: 8px;'>Request deletion ('right to be forgotten')</li>
          <li style='margin-bottom: 8px;'>Object to or restrict processing</li>
          <li style='margin-bottom: 8px;'>Withdraw consent at any time</li>
          <li style='margin-bottom: 8px;'>Request data portability (where applicable)</li>
        </ul>
        <p>To exercise these rights, contact us at <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Policy Updates",
      content: `
        <p>We may update this Policy to reflect changes in legal requirements or our data practices. The latest version will always be available on our website.</p>
      `
    },
    {
      title: "Contact Us",
      content: `
        <p>If you have questions or wish to exercise your rights, please contact us:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Danghuan Europe S.L.</li>
          <li style='margin-bottom: 8px;'>Email: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'>Website: <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>You may also file a complaint with your local data protection authority or with the Spanish Data Protection Agency (AEPD).</p>
      `
    },
    {
      title: "Addendum – Extended Legal and Cookie Information",
      subsections: [
        {
          title: "1. Legal Basis for Data Processing",
          content: `
            <p>The legal basis for processing your personal data includes:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Performance of a contract (e.g. processing trade-in orders, sending payments)</li>
              <li style='margin-bottom: 8px;'>Compliance with legal obligations (e.g. tax reporting, identity verification)</li>
              <li style='margin-bottom: 8px;'>Your consent (e.g. marketing communications or third-party cookies)</li>
              <li style='margin-bottom: 8px;'>Legitimate interests (e.g. fraud prevention, internal analytics, service improvement)</li>
            </ul>
          `
        },
        {
          title: "2. Fraud Prevention Measures",
          content: `
            <p>We may use your personal information (e.g. device serial number, transaction pattern, IP geolocation, IBAN ownership) to conduct fraud detection using publicly available databases and anti-fraud service providers. This is done under our legitimate interest in preventing identity theft and misuse of our services.</p>
            <p>We do not make decisions solely based on automated processing that significantly affect you.</p>
          `
        },
        {
          title: "3. Data Handling on External Marketplaces",
          content: `
            <p>If you purchase or sell devices via third-party platforms like Amazon, Shopify, TEMU, or Back Market, Danghuan may receive your order information, shipping address, and payment confirmation via encrypted API or secure back-office channel, solely for the purpose of fulfilling your transaction and providing after-sales support.</p>
          `
        },
        {
          title: "4. Cookie Categories and Details",
          content: `
            <p>You may review the full list of cookies we use — including name, provider, purpose, duration, and type (first-party or third-party) — in the table below. This includes analytics cookies from Google Analytics, retargeting cookies from Meta, and payment cookies from PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Category</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Cookie Name</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Provider</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Purpose</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Duration</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Type</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strictly Necessary</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Stores cookie preferences</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 year</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>First-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strictly Necessary</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Maintains session state across pages</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>First-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Functional</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Remembers selected language preference</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>First-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Functional</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Enables live chat support</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 months</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Performance</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Collects site usage statistics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 years</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Performance</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tracks user behavior across sessions</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 hours</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Performance</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Persists user session across pages</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 year</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Delivers personalized ads based on behavior</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 months</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tracks user interactions and conversions</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 months</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tracks users across websites for marketing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 day</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Used for conversion tracking</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 months</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Advertising</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identifies visitors for email marketing campaigns</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 years</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Third-party</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Promotions, Campaigns and Surveys",
          content: `
            <p>When you participate in our promotions, surveys, or contests, we may collect your name, contact details, and additional information specific to the event (e.g. age, location). This data is used solely to administer the event, contact winners, and improve future campaigns.</p>
          `
        },
        {
          title: "6. Supervisory Authorities",
          content: `
            <p>You may file a complaint with the following supervisory authorities if you believe your data rights have been violated:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>In the United Kingdom: Information Commissioner's Office (ICO) – <a href="https://www.ico.org.uk" target="_blank">www.ico.org.uk</a></li>
              <li style='margin-bottom: 8px;'>In the European Union: you can find the relevant national supervisory authority for your country on the website of the European Data Protection Board (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};